/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Tag_FootnoteInputs */

const en_why_listening_tag_footnote = /** @type {(inputs: Why_Listening_Tag_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Footnote skipped`)
};

const es_why_listening_tag_footnote = /** @type {(inputs: Why_Listening_Tag_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota al pie omitida`)
};

/**
* | output |
* | --- |
* | "Footnote skipped" |
*
* @param {Why_Listening_Tag_FootnoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_tag_footnote = /** @type {((inputs?: Why_Listening_Tag_FootnoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Tag_FootnoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_tag_footnote(inputs)
	return en_why_listening_tag_footnote(inputs)
});